import { render, staticRenderFns } from "./FooterColumn.vue?vue&type=template&id=63300531"
import script from "./FooterColumn.vue?vue&type=script&lang=js"
export * from "./FooterColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports